module.exports = __webpack_public_path__ + "img/t1-3.2570360a.png";